export default __webpack_public_path__ + "images/TV.36748df.png";